// extracted by mini-css-extract-plugin
export default {"ocularPatdownImage":"Skeleton_ocularPatdownImage__inLJf","fadeInOut":"Skeleton_fadeInOut__UW1HW"};